import type { Params } from '@angular/router';
import type { LandingPageUser } from '@common/types/user.type';

import { Injectable } from '@angular/core';
import { isUuid } from '@common/helpers';

@Injectable({
    providedIn: 'root',
})
export class LogService {
    public getInvalidUserTariffLogMessage(user: LandingPageUser, routerParam: Params): string {
        let message = 'Invalid user tariff! \n';
        if (!isUuid(routerParam.siteId)) {
            message += `Site ID: ${routerParam.siteId} \n`;
        }
        if (!isUuid(routerParam.pageId)) {
            message += `Page ID: ${routerParam.pageId} \n`;
        }

        if (user) {
            message += `User ID: ${user.user_id}`;
        } else {
            message += `User not found`;
        }

        return message;
    }
}
